import { createReducer, on } from '@ngrx/store'
import * as UserRulesAction from './user-rules.actions'

export const initialState = {}

export const userRulesReducer = createReducer(
  initialState,
  on(UserRulesAction.ReplaceUserRules, (state, { payload } ) => {
    return { userRules: payload }
  })
)
